import { encodedStringParser } from '../inboundParsers';
export const RESET_PASSWORD_ERROR_PAYLOAD_DEFINITION = {
    definitionParts: [{ name: 'error', parser: encodedStringParser }]
};
